{
  "schemaVersion": 1,
  "slug": "google-people",
  "name": "Google People",
  "description": "Search contacts and directory profiles with the Google People API.",
  "categories": [
    "communication",
    "productivity"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/google-people.svg"
  },
  "urlPatterns": [
    "https://people.googleapis.com/*"
  ],
  "docsUrl": "https://developers.google.com/people/api/mcp",
  "setupPrerequisite": {
    "title": "Google Developer Preview access required",
    "description": "Google must register both the Workspace email used to authorize Paperclip and the Google Cloud project that owns the OAuth client. Registration is limited to those emails and projects; it does not enable unrelated Paperclip customers.",
    "steps": [
      "Apply with the Workspace email that will sign in and the Google Cloud project that owns the OAuth client.",
      "Wait for the Google Group notification and then Google's final project-registration email, usually within a couple of days.",
      "Add every additional tester email or Cloud project through Google's member request forms before connecting."
    ],
    "actionLabel": "Apply or verify Developer Preview enrollment",
    "actionUrl": "https://developers.google.com/workspace/preview"
  },
  "redirectConstraints": "https-or-loopback-http",
  "methods": [
    {
      "key": "paperclip-read",
      "label": "Connect with Paperclip",
      "transport": "mcp_remote",
      "auth": "oauth",
      "oauthStrategy": "paperclip_cloud_connector",
      "connectorProfile": "people.read",
      "capabilityProfile": {
        "key": "read",
        "label": "Read contacts",
        "description": "Search contacts, directory people, and your profile."
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "platform_shared"
      ],
      "whenToUse": "Use Paperclip-managed OAuth for Google People access.",
      "defaults": {
        "serverUrl": "https://people.googleapis.com/mcp/v1",
        "scopesHint": [
          "https://www.googleapis.com/auth/directory.readonly",
          "https://www.googleapis.com/auth/userinfo.profile",
          "https://www.googleapis.com/auth/contacts.readonly"
        ]
      },
      "guidanceMd": "Connect Google People to search contacts and directory profiles.",
      "warnings": [
        "Google Workspace MCP servers are in Developer Preview."
      ],
      "riskTier": "S3"
    },
    {
      "key": "customer-read-oauth",
      "label": "Use your own Google OAuth app",
      "transport": "mcp_remote",
      "auth": "oauth",
      "capabilityProfile": {
        "key": "read",
        "label": "Read contacts",
        "description": "Search contacts, directory people, and your profile."
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use a customer-owned OAuth client for Google People access.",
      "defaults": {
        "serverUrl": "https://people.googleapis.com/mcp/v1",
        "authorizationEndpoint": "https://accounts.google.com/o/oauth2/v2/auth",
        "tokenEndpoint": "https://oauth2.googleapis.com/token",
        "metadataUrl": "https://accounts.google.com/.well-known/openid-configuration",
        "scopesHint": [
          "https://www.googleapis.com/auth/directory.readonly",
          "https://www.googleapis.com/auth/userinfo.profile",
          "https://www.googleapis.com/auth/contacts.readonly"
        ],
        "oauthAuthorizationParams": {
          "access_type": "offline",
          "prompt": "consent"
        }
      },
      "guidanceMd": "Enable the People and People MCP APIs, then register Paperclip's callback URI.",
      "consoleLinks": {
        "register": "https://console.cloud.google.com/auth/clients",
        "docs": "https://developers.google.com/workspace/guides/configure-mcp-servers"
      },
      "warnings": [
        "Directory search availability depends on your Workspace account.",
        "Google Workspace MCP servers are in Developer Preview."
      ],
      "riskTier": "S3"
    }
  ]
}
